import { render, staticRenderFns } from "./tutor-log.vue?vue&type=template&id=2f554c8d&scoped=true&"
import script from "./tutor-log.vue?vue&type=script&lang=js&"
export * from "./tutor-log.vue?vue&type=script&lang=js&"
import style0 from "./tutor-log.vue?vue&type=style&index=0&id=2f554c8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f554c8d",
  null
  
)

export default component.exports